const data = {}

const tickerInit = () => {
  data.pause = false
  data.step = 0
  data.ticker = document.getElementById('ticker')
  if (data.ticker) {
    data.scroller = data.ticker.childNodes[0]
    data.tickerWidth = data.ticker.offsetWidth
    data.scrollerWidth = data.scroller.offsetWidth
    setPos(0)
    data.interval = setInterval(scrollTicker, 30)
    data.ticker.addEventListener("mouseover", () => {
      data.pause = true;
    });
    data.ticker.addEventListener("mouseout", () => {
      data.pause = false;
    });
  }
}

const setPos = (pos) => {
  data.pos = pos
  data.scroller.style.left = (data.tickerWidth - data.pos) + 'px'
}

const scrollTicker = () => {
  if (data.pause && data.step > 0) {
    data.step--
  } else if (!data.pause && data.step < 3) {
    data.step++
  }
  setPos(data.pos+data.step)
  if (data.pos > data.scrollerWidth + data.tickerWidth + 50) {
    data.pos= 0
  }
}

window.addEventListener('load', tickerInit)
